/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{__decorate as r}from"tslib";import{subclass as e}from"../../core/accessorSupport/decorators.js";import o from"./GraphObject.js";let t=class extends o{constructor(r){super(r)}};t=r([e("esri.rest.knowledgeGraph.ObjectValue")],t);export{t as default};
